export const AboutHtmlTriggerPercentage = -0.1
export const ContactHtmlTriggerPercentage = 0.4
